export function normalizeToDateOnly(dateValue: Date | string | null | undefined): Date | null {
  if (!dateValue) {
    return null;
  }

  const buildDate = (year: number, month: number, day: number): Date | null => {
    const date = new Date(year, month - 1, day);
    const isValidDate =
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day;

    return isValidDate ? date : null;
  };

  if (typeof dateValue === 'string') {
    const trimmedValue = dateValue.trim();

    const isoDateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(trimmedValue);
    if (isoDateMatch) {
      const [, year, month, day] = isoDateMatch;
      return buildDate(Number(year), Number(month), Number(day));
    }

    const brDateMatch = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(trimmedValue);
    if (brDateMatch) {
      const [, day, month, year] = brDateMatch;
      return buildDate(Number(year), Number(month), Number(day));
    }

    return null;
  }

  if (dateValue instanceof Date) {
    return new Date(dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate());
  }

  return null;
}

export function formatDateOnlyToIso(dateValue: Date | string | null | undefined): string | null {
  const normalizedDate = normalizeToDateOnly(dateValue);

  if (!normalizedDate) {
    return null;
  }

  const year = normalizedDate.getFullYear();
  const month = String(normalizedDate.getMonth() + 1).padStart(2, '0');
  const day = String(normalizedDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
